<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title">
          <div class="text-center">دوره {{ history.Title }}</div>
        </v-card-title>
        <div>
          <app-row
            icon="building"
            title="معاونت:"
            :value="history.Category"
          />
          <app-row icon="hashtag" title="امتیاز:" :value="history.Score" />

          <app-row icon="signal" title="سطح دوره:" :value="history.Sath" />
          <app-row
            icon="user"
            title="برگزار کننده:"
            :value="history.Producer"
          />
          <app-row
            :icon="['far', 'calendar-check']"
            title="مدت دوره:"
            :value="history.Duration"
          />
          <app-row
            icon="calendar-alt"
            title="تاریخ شروع دوره:"
            :value="history.TarikhStart"
          />

          <app-row
            icon="download"
            title="دریافت مدرک:"
            :showButton="true"
            buttonText="دانلود"
            @clicked="$emit('clicked', history.RegisterID)"
            v-if="history.IsPrintable == 1"
          />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["history"],
  components: {
    appRow: DetailRow,
  },
};
</script>

